import { EventEmitter, Component, ChangeDetectionStrategy, ChangeDetectorRef, Input, Output, NgModule } from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { breakpointBelow, ResponsiveService, SharedDirectiveModule, B2CSharedResponsiveModule } from 'b2c-ui/core';
import { tap } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { EventLocationIcon, EventTimeIcon, B2cUiIconModule, B2CUiIconService } from 'b2c-ui-icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { RouterModule } from '@angular/router';

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-event-card.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * ##### Import this component individually to your module
 * `import { B2CEventCardModule } from 'b2c-ui/event-card';`
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'b2c-ui/core';
import * as ɵngcc2 from 'ng-zorro-antd/grid';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@angular/router';
import * as ɵngcc5 from 'b2c-ui-icon';
import * as ɵngcc6 from 'ng-zorro-antd/tooltip';
import * as ɵngcc7 from 'ng-zorro-antd/button';

function B2CEventCardComponent_div_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 24);
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext(2);
    const _r14 = ɵngcc0.ɵɵreference(24);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r14);
} }
const _c0 = function (a0) { return { "mr-3": a0 }; };
function B2CEventCardComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "div", 21);
    ɵngcc0.ɵɵtemplate(2, B2CEventCardComponent_div_1_ng_container_2_Template, 1, 1, "ng-container", 7);
    ɵngcc0.ɵɵelementStart(3, "a", 22);
    ɵngcc0.ɵɵlistener("click", function B2CEventCardComponent_div_1_Template_a_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.onImageClick(); });
    ɵngcc0.ɵɵelement(4, "img", 23);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("nzSpan", ctx_r0.isMobile ? 24 : 14);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c0, !ctx_r0.isMobile));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isMobile);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("link", ctx_r0.imageUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("src", ctx_r0.eventImage, ɵngcc0.ɵɵsanitizeUrl);
} }
function B2CEventCardComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 25);
    ɵngcc0.ɵɵelementStart(1, "p");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "p");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.day);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.month);
} }
function B2CEventCardComponent_ng_template_6_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function B2CEventCardComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 25);
    ɵngcc0.ɵɵelementStart(1, "p");
    ɵngcc0.ɵɵtemplate(2, B2CEventCardComponent_ng_template_6_ng_container_2_Template, 1, 0, "ng-container", 26);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r3.customDateField);
} }
function B2CEventCardComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 24);
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r14 = ɵngcc0.ɵɵreference(24);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r14);
} }
const _c1 = function (a0) { return { "isMobile": a0 }; };
function B2CEventCardComponent_a_10_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 27);
    ɵngcc0.ɵɵlistener("click", function B2CEventCardComponent_a_10_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20.onTitleClick(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("link", "//" + ctx_r5.titleUrl)("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c1, ctx_r5.isMobile));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r5.title, " ");
} }
function B2CEventCardComponent_div_11_a_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 30);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("href", ctx_r22.eventURL, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c1, ctx_r22.isMobile))("target", "_blank");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r22.title, " ");
} }
function B2CEventCardComponent_div_11_a_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 31);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("href", ctx_r23.eventURL, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c1, ctx_r23.isMobile))("routerLink", ctx_r23.eventURL);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r23.title, " ");
} }
function B2CEventCardComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, B2CEventCardComponent_div_11_a_1_Template, 2, 6, "a", 28);
    ɵngcc0.ɵɵtemplate(2, B2CEventCardComponent_div_11_a_2_Template, 2, 6, "a", 29);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.openEventInCurrentTab == null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.openEventInCurrentTab != null && ctx_r6.openEventInCurrentTab == true);
} }
function B2CEventCardComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelementStart(1, "div", 32);
    ɵngcc0.ɵɵelement(2, "b2c-ui-icon", 33);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span", 34);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r7.time, " ");
} }
function B2CEventCardComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 32);
    ɵngcc0.ɵɵelement(1, "b2c-ui-icon", 35);
    ɵngcc0.ɵɵelementEnd();
} }
function B2CEventCardComponent_div_18_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r27 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 38);
    ɵngcc0.ɵɵlistener("click", function B2CEventCardComponent_div_18_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r27); const ctx_r26 = ɵngcc0.ɵɵnextContext(2); return ctx_r26.onClick(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r24.buttonDisabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r24.button, " ");
} }
function B2CEventCardComponent_div_18_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r29 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 39);
    ɵngcc0.ɵɵelementStart(1, "button", 38);
    ɵngcc0.ɵɵlistener("click", function B2CEventCardComponent_div_18_a_2_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r29); const ctx_r28 = ɵngcc0.ɵɵnextContext(2); return ctx_r28.onClick(); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("href", ctx_r25.buttonURL, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵproperty("target", "_blank");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", ctx_r25.buttonDisabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r25.button, " ");
} }
function B2CEventCardComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 36);
    ɵngcc0.ɵɵtemplate(1, B2CEventCardComponent_div_18_button_1_Template, 2, 2, "button", 37);
    ɵngcc0.ɵɵtemplate(2, B2CEventCardComponent_div_18_a_2_Template, 3, 4, "a", 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("nzTooltipTitle", ctx_r9.buttonTooltipText);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r9.buttonURL == null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r9.buttonURL != null);
} }
function B2CEventCardComponent_div_19_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r33 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 41);
    ɵngcc0.ɵɵlistener("click", function B2CEventCardComponent_div_19_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r33); const ctx_r32 = ɵngcc0.ɵɵnextContext(2); return ctx_r32.onClick(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r30.button, " ");
} }
function B2CEventCardComponent_div_19_a_2_button_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 43);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r34.button, " ");
} }
function B2CEventCardComponent_div_19_a_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 39);
    ɵngcc0.ɵɵtemplate(1, B2CEventCardComponent_div_19_a_2_button_1_Template, 2, 1, "button", 42);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r31 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("href", ctx_r31.buttonURL, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵproperty("target", "_blank");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r31.isMobile && ctx_r31.button && !ctx_r31.buttonTooltipText);
} }
function B2CEventCardComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, B2CEventCardComponent_div_19_button_1_Template, 2, 1, "button", 40);
    ɵngcc0.ɵɵtemplate(2, B2CEventCardComponent_div_19_a_2_Template, 2, 3, "a", 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r10.isMobile && ctx_r10.button && !ctx_r10.buttonTooltipText && ctx_r10.buttonURL == null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r10.buttonURL != null);
} }
function B2CEventCardComponent_div_20_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r38 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 46);
    ɵngcc0.ɵɵlistener("click", function B2CEventCardComponent_div_20_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r38); const ctx_r37 = ɵngcc0.ɵɵnextContext(2); return ctx_r37.onClick(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r35 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r35.buttonDisabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r35.button, " ");
} }
function B2CEventCardComponent_div_20_a_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 39);
    ɵngcc0.ɵɵelementStart(1, "button", 47);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r36 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("href", ctx_r36.buttonURL, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵproperty("target", "_blank");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", ctx_r36.buttonDisabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r36.button, " ");
} }
function B2CEventCardComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 44);
    ɵngcc0.ɵɵtemplate(1, B2CEventCardComponent_div_20_button_1_Template, 2, 2, "button", 45);
    ɵngcc0.ɵɵtemplate(2, B2CEventCardComponent_div_20_a_2_Template, 3, 4, "a", 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("nzTooltipTitle", ctx_r11.buttonTooltipText);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r11.buttonURL == null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r11.buttonURL != null);
} }
function B2CEventCardComponent_button_21_Template(rf, ctx) { if (rf & 1) {
    const _r40 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 48);
    ɵngcc0.ɵɵlistener("click", function B2CEventCardComponent_button_21_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r40); const ctx_r39 = ɵngcc0.ɵɵnextContext(); return ctx_r39.onClick(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r12.button, " ");
} }
function B2CEventCardComponent_a_22_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r43 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 48);
    ɵngcc0.ɵɵlistener("click", function B2CEventCardComponent_a_22_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r43); const ctx_r42 = ɵngcc0.ɵɵnextContext(2); return ctx_r42.onClick(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r41 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r41.button, " ");
} }
function B2CEventCardComponent_a_22_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 39);
    ɵngcc0.ɵɵtemplate(1, B2CEventCardComponent_a_22_button_1_Template, 2, 1, "button", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("href", ctx_r13.buttonURL, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵproperty("target", "_blank");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r13.isMobile && ctx_r13.button && !ctx_r13.buttonTooltipText);
} }
function B2CEventCardComponent_ng_template_23_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 50);
    ɵngcc0.ɵɵelementStart(1, "p");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r44 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c1, ctx_r44.isMobile));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r44.eventStatus);
} }
function B2CEventCardComponent_ng_template_23_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, B2CEventCardComponent_ng_template_23_div_0_Template, 3, 4, "div", 49);
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r15.eventStatus);
} }
const _c2 = function (a0) { return { "isMobile px-1": a0 }; };
class B2CEventCardComponent {
    /**
     * @param {?} responsiveService
     * @param {?} cdRef
     */
    constructor(responsiveService, cdRef) {
        this.responsiveService = responsiveService;
        this.cdRef = cdRef;
        this._isMobile = false;
        this._buttonDisabled = false;
        /**
         * Set Custom Url
         */
        this.customDateField = null;
        /**
         * Button on Click Event
         */
        this.buttonEvent = new EventEmitter();
        /**
         * Title on Click Event
         */
        this.titleEvent = new EventEmitter();
        /**
         * Event Image on Click Event
         */
        this.imageEvent = new EventEmitter();
        this.responsiveService
            .observeBoolean(breakpointBelow.sm)
            .pipe(tap((/**
         * @param {?} matched
         * @return {?}
         */
        (matched) => {
            this.isMobile = matched;
            this.buttonDisabled = matched;
            this.cdRef.markForCheck();
        })))
            .subscribe();
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set date(value) {
        /** @type {?} */
        const nativeDate = this.checkDateType(value)
            .toString()
            .split(' ');
        this.day = nativeDate[2];
        this.month = nativeDate[1];
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set isMobile(value) {
        this._isMobile = this.coerceBoolean(value);
    }
    /**
     * @return {?}
     */
    get isMobile() {
        return this._isMobile;
    }
    /**
     * Set Button Disabled
     * @param {?} value
     * @return {?}
     */
    set buttonDisabled(value) {
        this._buttonDisabled = this.coerceBoolean(value);
    }
    /**
     * @return {?}
     */
    get buttonDisabled() {
        return this._buttonDisabled;
    }
    /**
     * @ignore
     * @return {?}
     */
    onClick() {
        this.buttonEvent.emit();
    }
    /**
     * @ignore
     * @return {?}
     */
    onTitleClick() {
        this.titleEvent.emit();
    }
    /**
     * @ignore
     * @return {?}
     */
    onImageClick() {
        this.imageEvent.emit();
    }
    /**
     * @ignore
     * @return {?}
     */
    _onClick_() {
        this.buttonEvent.emit('event button works');
    }
    /**
     * @ignore
     * @private
     * @param {?} value
     * @return {?}
     */
    checkDateType(value) {
        if (typeof value === 'string' || typeof value === 'number') {
            return new Date(value);
        }
        else {
            return value;
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    coerceBoolean(value) {
        return coerceBooleanProperty(value);
    }
}
B2CEventCardComponent.ɵfac = function B2CEventCardComponent_Factory(t) { return new (t || B2CEventCardComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ResponsiveService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
B2CEventCardComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: B2CEventCardComponent, selectors: [["b2c-event-card"]], inputs: { customDateField: "customDateField", isMobile: "isMobile", buttonDisabled: "buttonDisabled", date: "date", buttonURL: "buttonURL", openEventInCurrentTab: "openEventInCurrentTab", eventURL: "eventURL", eventImage: "eventImage", eventStatus: "eventStatus", title: "title", time: "time", location: "location", button: "button", titleUrl: "titleUrl", imageUrl: "imageUrl", buttonTooltipText: "buttonTooltipText" }, outputs: { buttonEvent: "buttonEvent", titleEvent: "titleEvent", imageEvent: "imageEvent" }, decls: 25, vars: 21, consts: [["nz-row", "", 1, "m-2"], ["nz-col", "", 3, "nzSpan", 4, "ngIf"], ["nz-col", "", 1, "b2c-event-card", 3, "nzSpan", "nzOffset", "ngClass"], ["nz-row", ""], ["nz-col", "", 1, "b2c-event-date-outer", 3, "nzSpan"], ["class", "text-center b2c-event-date", 4, "ngIf", "ngIfElse"], ["customDateTemplate", ""], [3, "ngTemplateOutlet", 4, "ngIf"], ["nz-col", "", 3, "nzSpan"], ["external", "", "class", "b2c-event-title _title_", 3, "link", "ngClass", "click", 4, "ngIf"], [4, "ngIf"], ["nz-row", "", 1, "b2c-event-info"], ["nz-col", "", "nzSpan", "24", 4, "ngIf"], ["nz-col", "", "nzSpan", "24"], ["nz-col", "", "nzSpan", "2", 4, "ngIf"], ["nz-col", "", "nzSpan", "21", 1, "pl-1", "event-location", "font-weight-normal", 2, "word-wrap", "break-word", "display", "block"], ["nz-tooltip", "", "nzTooltipPlacement", "top", "class", "float-right", 3, "nzTooltipTitle", 4, "ngIf"], ["class", "position-absolute", "style", "bottom: 0; right: 0;", "nz-tooltip", "", "nzTooltipPlacement", "top", 3, "nzTooltipTitle", 4, "ngIf"], ["class", "position-absolute", "style", "bottom: 0; right: 0;", "nz-button", "", "nzType", "primary", "nzSize", "small", 3, "click", 4, "ngIf"], [3, "href", "target", 4, "ngIf"], ["eventStatusTemplate", ""], [3, "ngClass"], ["external", "", 3, "link", "click"], ["alt", "Image for the according event display here", "role", "button", 1, "img-fluid", "rounded", 3, "src"], [3, "ngTemplateOutlet"], [1, "text-center", "b2c-event-date"], [4, "ngTemplateOutlet"], ["external", "", 1, "b2c-event-title", "_title_", 3, "link", "ngClass", "click"], ["class", "b2c-event-title _title_", 3, "ngClass", "href", "target", 4, "ngIf"], ["class", "b2c-event-title _title_", 3, "ngClass", "href", "routerLink", 4, "ngIf"], [1, "b2c-event-title", "_title_", 3, "ngClass", "href", "target"], [1, "b2c-event-title", "_title_", 3, "ngClass", "href", "routerLink"], ["nz-col", "", "nzSpan", "2"], ["name", "eventTimeIcon"], ["nz-col", "", "nzSpan", "22", 1, "font-weight-normal", 2, "padding-left", "2px"], ["name", "eventLocationIcon"], ["nz-tooltip", "", "nzTooltipPlacement", "top", 1, "float-right", 3, "nzTooltipTitle"], ["nz-button", "", "nzType", "primary", "nzSize", "default", 3, "disabled", "click", 4, "ngIf"], ["nz-button", "", "nzType", "primary", "nzSize", "default", 3, "disabled", "click"], [3, "href", "target"], ["nz-button", "", "nzType", "primary", "nzSize", "default", "class", "float-right", 3, "click", 4, "ngIf"], ["nz-button", "", "nzType", "primary", "nzSize", "default", 1, "float-right", 3, "click"], ["nz-button", "", "nzType", "primary", "nzSize", "default", "class", "float-right", 4, "ngIf"], ["nz-button", "", "nzType", "primary", "nzSize", "default", 1, "float-right"], ["nz-tooltip", "", "nzTooltipPlacement", "top", 1, "position-absolute", 2, "bottom", "0", "right", "0", 3, "nzTooltipTitle"], ["nz-button", "", "nzType", "primary", "nzSize", "small", 3, "disabled", "click", 4, "ngIf"], ["nz-button", "", "nzType", "primary", "nzSize", "small", 3, "disabled", "click"], ["nz-button", "", "nzType", "primary", "nzSize", "small", 3, "disabled"], ["nz-button", "", "nzType", "primary", "nzSize", "small", 1, "position-absolute", 2, "bottom", "0", "right", "0", 3, "click"], ["nz-col", "", "nzSpan", "4", "class", "b2c-event-status rounded-circle _event-status_", 3, "ngClass", 4, "ngIf"], ["nz-col", "", "nzSpan", "4", 1, "b2c-event-status", "rounded-circle", "_event-status_", 3, "ngClass"]], template: function B2CEventCardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, B2CEventCardComponent_div_1_Template, 5, 7, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵtemplate(5, B2CEventCardComponent_div_5_Template, 5, 2, "div", 5);
        ɵngcc0.ɵɵtemplate(6, B2CEventCardComponent_ng_template_6_Template, 3, 1, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, B2CEventCardComponent_ng_container_8_Template, 1, 1, "ng-container", 7);
        ɵngcc0.ɵɵelementStart(9, "div", 8);
        ɵngcc0.ɵɵtemplate(10, B2CEventCardComponent_a_10_Template, 2, 5, "a", 9);
        ɵngcc0.ɵɵtemplate(11, B2CEventCardComponent_div_11_Template, 3, 2, "div", 10);
        ɵngcc0.ɵɵelementStart(12, "div", 11);
        ɵngcc0.ɵɵtemplate(13, B2CEventCardComponent_div_13_Template, 5, 1, "div", 12);
        ɵngcc0.ɵɵelementStart(14, "div", 13);
        ɵngcc0.ɵɵtemplate(15, B2CEventCardComponent_div_15_Template, 2, 0, "div", 14);
        ɵngcc0.ɵɵelementStart(16, "div", 15);
        ɵngcc0.ɵɵtext(17);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(18, B2CEventCardComponent_div_18_Template, 3, 3, "div", 16);
        ɵngcc0.ɵɵtemplate(19, B2CEventCardComponent_div_19_Template, 3, 2, "div", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(20, B2CEventCardComponent_div_20_Template, 3, 3, "div", 17);
        ɵngcc0.ɵɵtemplate(21, B2CEventCardComponent_button_21_Template, 2, 1, "button", 18);
        ɵngcc0.ɵɵtemplate(22, B2CEventCardComponent_a_22_Template, 2, 3, "a", 19);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(23, B2CEventCardComponent_ng_template_23_Template, 1, 1, "ng-template", null, 20, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r2 = ɵngcc0.ɵɵreference(7);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.eventImage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("nzSpan", ctx.isMobile ? 24 : 10)("nzOffset", ctx.isMobile ? 0 : 0)("ngClass", ɵngcc0.ɵɵpureFunction1(19, _c2, ctx.isMobile));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("nzSpan", ctx.isMobile ? 4 : 20);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.customDateField)("ngIfElse", _r2);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isMobile);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("nzSpan", ctx.isMobile ? 20 : 24);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.eventURL == null);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.eventURL != null);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.time);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.location);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.location, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isMobile && ctx.button && ctx.buttonTooltipText);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isMobile && ctx.button && !ctx.buttonTooltipText);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isMobile && ctx.button && ctx.buttonTooltipText);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isMobile && ctx.button && !ctx.buttonTooltipText && ctx.buttonURL == null);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.buttonURL != null);
    } }, directives: [ɵngcc2.NzRowDirective, ɵngcc3.NgIf, ɵngcc2.NzColDirective, ɵngcc3.NgClass, ɵngcc1.ExternalLinkDirective, ɵngcc3.NgTemplateOutlet, ɵngcc4.RouterLinkWithHref, ɵngcc5.B2CUiIconComponent, ɵngcc6.NzTooltipDirective, ɵngcc7.NzButtonComponent], encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
B2CEventCardComponent.ctorParameters = () => [
    { type: ResponsiveService },
    { type: ChangeDetectorRef }
];
B2CEventCardComponent.propDecorators = {
    date: [{ type: Input }],
    isMobile: [{ type: Input }],
    buttonURL: [{ type: Input }],
    openEventInCurrentTab: [{ type: Input }],
    eventURL: [{ type: Input }],
    eventImage: [{ type: Input }],
    eventStatus: [{ type: Input }],
    title: [{ type: Input }],
    time: [{ type: Input }],
    location: [{ type: Input }],
    button: [{ type: Input }],
    titleUrl: [{ type: Input }],
    imageUrl: [{ type: Input }],
    customDateField: [{ type: Input }],
    buttonDisabled: [{ type: Input }],
    buttonTooltipText: [{ type: Input }],
    buttonEvent: [{ type: Output }],
    titleEvent: [{ type: Output }],
    imageEvent: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CEventCardComponent, [{
        type: Component,
        args: [{
                selector: 'b2c-event-card',
                template: "<div nz-row class=\"m-2\">\r\n  <div nz-col [nzSpan]=\"isMobile ? 24 : 14\" *ngIf=\"eventImage\">\r\n    <div [ngClass]=\"{'mr-3': !isMobile}\">\r\n      <ng-container [ngTemplateOutlet]=\"eventStatusTemplate\" *ngIf=\"isMobile\"></ng-container>\r\n      <a external [link]=\"imageUrl\" (click)=\"onImageClick()\">\r\n        <img class=\"img-fluid rounded\" [src]=\"eventImage\" alt=\"Image for the according event display here\" role=\"button\">\r\n      </a>\r\n    </div>\r\n  </div>\r\n  <div class=\"b2c-event-card\" nz-col [nzSpan]=\"isMobile ? 24 : 10\" [nzOffset]=\"isMobile ? 0 : 0\" [ngClass]=\"{'isMobile px-1': isMobile}\">\r\n    <div nz-row>\r\n      <div nz-col [nzSpan]=\"isMobile ? 4 : 20\" class=\"b2c-event-date-outer\">\r\n        <div class=\"text-center b2c-event-date\"  *ngIf=\"!customDateField; else customDateTemplate\">\r\n          <p>{{ day }}</p>\r\n          <p>{{ month }}</p>\r\n        </div>\r\n        <ng-template #customDateTemplate>\r\n          <div class=\"text-center b2c-event-date\">\r\n            <p>\r\n              <ng-container *ngTemplateOutlet=\"customDateField\"></ng-container>\r\n            </p>\r\n          </div>\r\n        </ng-template>\r\n      </div>\r\n      <ng-container [ngTemplateOutlet]=\"eventStatusTemplate\" *ngIf=\"!isMobile\"></ng-container>\r\n      <div nz-col [nzSpan]=\"isMobile ? 20 : 24\">\r\n        <a *ngIf=\"eventURL == null\" external [link]=\"'//' + titleUrl\" class=\"b2c-event-title _title_\" [ngClass]=\"{'isMobile': isMobile}\" (click)=\"onTitleClick()\">\r\n          {{ title }}\r\n        </a>\r\n        <div *ngIf=\"eventURL != null\">\r\n          <a *ngIf=\"openEventInCurrentTab == null\" class=\"b2c-event-title _title_\" [ngClass]=\"{'isMobile': isMobile}\" href=\"{{eventURL}}\" [target]=\"'_blank'\">\r\n            {{ title }}\r\n          </a>\r\n          <a *ngIf=\"openEventInCurrentTab != null && openEventInCurrentTab == true\" class=\"b2c-event-title _title_\" [ngClass]=\"{'isMobile': isMobile}\" href=\"{{eventURL}}\" [routerLink]=\"eventURL\">\r\n            {{ title }}\r\n          </a>\r\n        </div>\r\n        <div nz-row class=\"b2c-event-info\">\r\n          <div nz-col nzSpan=\"24\" *ngIf=\"time\">\r\n            <div nz-col nzSpan=\"2\">\r\n              <b2c-ui-icon name=\"eventTimeIcon\"></b2c-ui-icon>\r\n            </div>\r\n            <span nz-col nzSpan=\"22\" class=\"font-weight-normal\" style=\"padding-left: 2px;\">\r\n              {{ time }}\r\n            </span>\r\n          </div>\r\n          <div nz-col nzSpan=\"24\">\r\n            <div nz-col nzSpan=\"2\" *ngIf=\"location\">\r\n              <b2c-ui-icon name=\"eventLocationIcon\"></b2c-ui-icon>\r\n            </div>\r\n            <div nz-col nzSpan=\"21\" class=\"pl-1 event-location font-weight-normal\" style=\"word-wrap:break-word;display:block;\">\r\n              {{ location }}\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div *ngIf=\"!isMobile && button && buttonTooltipText\" nz-tooltip [nzTooltipTitle]=\"buttonTooltipText\" nzTooltipPlacement=\"top\" class=\"float-right\">\r\n          <button *ngIf=\"buttonURL== null\"\r\n                  nz-button\r\n                  nzType=\"primary\"\r\n                  nzSize=\"default\"\r\n                  [disabled]=\"buttonDisabled\"\r\n                  (click)=\"onClick()\">\r\n            {{ button }}\r\n          </button>\r\n          <a *ngIf=\"buttonURL!= null\" href=\"{{buttonURL}}\" [target]=\"'_blank'\">\r\n            <button\r\n                    nz-button\r\n                    nzType=\"primary\"\r\n                    nzSize=\"default\"\r\n                    [disabled]=\"buttonDisabled\"\r\n                    (click)=\"onClick()\">\r\n              {{ button }}\r\n            </button>\r\n          </a>\r\n        </div>\r\n        <div *ngIf=\"!isMobile && button && !buttonTooltipText\">\r\n          <button *ngIf=\"!isMobile && button && !buttonTooltipText && buttonURL == null\"\r\n                  nz-button\r\n                  nzType=\"primary\"\r\n                  nzSize=\"default\"\r\n                  class=\"float-right\"\r\n                  (click)=\"onClick()\">\r\n            {{ button }}\r\n          </button>\r\n          <a *ngIf=\"buttonURL != null\" href=\"{{buttonURL}}\" [target]=\"'_blank'\">\r\n            <button *ngIf=\"!isMobile && button && !buttonTooltipText\"\r\n                    nz-button\r\n                    nzType=\"primary\"\r\n                    nzSize=\"default\"\r\n                    class=\"float-right\">\r\n              {{ button }}\r\n            </button>\r\n          </a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n    <div *ngIf=\"isMobile && button && buttonTooltipText\" class=\"position-absolute\" style=\"bottom: 0; right: 0;\" nz-tooltip [nzTooltipTitle]=\"buttonTooltipText\" nzTooltipPlacement=\"top\">\r\n      <button *ngIf=\"buttonURL == null\"\r\n              nz-button\r\n              nzType=\"primary\"\r\n              nzSize=\"small\"\r\n              [disabled]=\"buttonDisabled\"\r\n              (click)=\"onClick()\">\r\n        {{ button }}\r\n      </button>\r\n      <a *ngIf=\"buttonURL != null\" href=\"{{buttonURL}}\" [target]=\"'_blank'\">\r\n        <button\r\n                nz-button\r\n                nzType=\"primary\"\r\n                nzSize=\"small\"\r\n                [disabled]=\"buttonDisabled\">\r\n          {{ button }}\r\n        </button>\r\n      </a>\r\n    </div>\r\n  <button *ngIf=\"isMobile && button && !buttonTooltipText && buttonURL == null\" class=\"position-absolute\" style=\"bottom: 0; right: 0;\"\r\n          nz-button\r\n          nzType=\"primary\"\r\n          nzSize=\"small\"\r\n          (click)=\"onClick()\">\r\n    {{ button }}\r\n  </button>\r\n  <a *ngIf=\"buttonURL != null\" href=\"{{buttonURL}}\" [target]=\"'_blank'\">\r\n    <button *ngIf=\"isMobile && button && !buttonTooltipText\" class=\"position-absolute\" style=\"bottom: 0; right: 0;\"\r\n            nz-button\r\n            nzType=\"primary\"\r\n            nzSize=\"small\"\r\n            (click)=\"onClick()\">\r\n      {{ button }}\r\n    </button>\r\n  </a>\r\n</div>\r\n\r\n<ng-template #eventStatusTemplate>\r\n  <div [ngClass]=\"{'isMobile': isMobile}\" nz-col nzSpan=\"4\" class=\"b2c-event-status rounded-circle _event-status_\" *ngIf=\"eventStatus\">\r\n    <p>{{ eventStatus }}</p>\r\n  </div>\r\n</ng-template>\r\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc1.ResponsiveService }, { type: ɵngcc0.ChangeDetectorRef }]; }, { customDateField: [{
            type: Input
        }], buttonEvent: [{
            type: Output
        }], titleEvent: [{
            type: Output
        }], imageEvent: [{
            type: Output
        }], isMobile: [{
            type: Input
        }], buttonDisabled: [{
            type: Input
        }], date: [{
            type: Input
        }], buttonURL: [{
            type: Input
        }], openEventInCurrentTab: [{
            type: Input
        }], eventURL: [{
            type: Input
        }], eventImage: [{
            type: Input
        }], eventStatus: [{
            type: Input
        }], title: [{
            type: Input
        }], time: [{
            type: Input
        }], location: [{
            type: Input
        }], button: [{
            type: Input
        }], titleUrl: [{
            type: Input
        }], imageUrl: [{
            type: Input
        }], buttonTooltipText: [{
            type: Input
        }] }); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    B2CEventCardComponent.prototype._isMobile;
    /**
     * @type {?}
     * @private
     */
    B2CEventCardComponent.prototype._buttonDisabled;
    /** @type {?} */
    B2CEventCardComponent.prototype.month;
    /** @type {?} */
    B2CEventCardComponent.prototype.day;
    /**
     * Set URL for button clicking
     * @type {?}
     */
    B2CEventCardComponent.prototype.buttonURL;
    /**
     * Set whether to open event in new tab
     * @type {?}
     */
    B2CEventCardComponent.prototype.openEventInCurrentTab;
    /**
     * Set Event Image Url
     * @type {?}
     */
    B2CEventCardComponent.prototype.eventURL;
    /**
     * Set Event Image Url
     * @type {?}
     */
    B2CEventCardComponent.prototype.eventImage;
    /**
     * Set Event Status
     * @type {?}
     */
    B2CEventCardComponent.prototype.eventStatus;
    /**
     * Set Event Title
     * @type {?}
     */
    B2CEventCardComponent.prototype.title;
    /**
     * Set Event Time
     * @type {?}
     */
    B2CEventCardComponent.prototype.time;
    /**
     * Set Event Location
     * @type {?}
     */
    B2CEventCardComponent.prototype.location;
    /**
     * Set Button Text
     * @type {?}
     */
    B2CEventCardComponent.prototype.button;
    /**
     * Set Title Url
     * @type {?}
     */
    B2CEventCardComponent.prototype.titleUrl;
    /**
     * Set Image Url
     * @type {?}
     */
    B2CEventCardComponent.prototype.imageUrl;
    /**
     * Set Custom Url
     * @type {?}
     */
    B2CEventCardComponent.prototype.customDateField;
    /**
     * Set Button Tooltip Text
     * @type {?}
     */
    B2CEventCardComponent.prototype.buttonTooltipText;
    /**
     * Button on Click Event
     * @type {?}
     */
    B2CEventCardComponent.prototype.buttonEvent;
    /**
     * Title on Click Event
     * @type {?}
     */
    B2CEventCardComponent.prototype.titleEvent;
    /**
     * Event Image on Click Event
     * @type {?}
     */
    B2CEventCardComponent.prototype.imageEvent;
    /**
     * @type {?}
     * @private
     */
    B2CEventCardComponent.prototype.responsiveService;
    /**
     * @type {?}
     * @private
     */
    B2CEventCardComponent.prototype.cdRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-event-card.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const ICONS = [EventLocationIcon, EventTimeIcon];
class B2CEventCardModule {
    /**
     * @param {?} b2cIconService
     */
    constructor(b2cIconService) {
        this.b2cIconService = b2cIconService;
        this.b2cIconService.registerIcons([...ICONS]);
    }
}
B2CEventCardModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: B2CEventCardModule });
B2CEventCardModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function B2CEventCardModule_Factory(t) { return new (t || B2CEventCardModule)(ɵngcc0.ɵɵinject(ɵngcc5.B2CUiIconService)); }, imports: [[
            CommonModule,
            NzGridModule,
            NzButtonModule,
            SharedDirectiveModule,
            B2CSharedResponsiveModule,
            B2cUiIconModule,
            NzToolTipModule,
            RouterModule
        ]] });
/** @nocollapse */
B2CEventCardModule.ctorParameters = () => [
    { type: B2CUiIconService }
];
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(B2CEventCardModule, { declarations: function () { return [B2CEventCardComponent]; }, imports: function () { return [CommonModule,
        NzGridModule,
        NzButtonModule,
        SharedDirectiveModule,
        B2CSharedResponsiveModule,
        B2cUiIconModule,
        NzToolTipModule,
        RouterModule]; }, exports: function () { return [B2CEventCardComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CEventCardModule, [{
        type: NgModule,
        args: [{
                declarations: [B2CEventCardComponent],
                exports: [B2CEventCardComponent],
                imports: [
                    CommonModule,
                    NzGridModule,
                    NzButtonModule,
                    SharedDirectiveModule,
                    B2CSharedResponsiveModule,
                    B2cUiIconModule,
                    NzToolTipModule,
                    RouterModule
                ]
            }]
    }], function () { return [{ type: ɵngcc5.B2CUiIconService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    B2CEventCardModule.prototype.b2cIconService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-ui-event-card.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { B2CEventCardComponent, B2CEventCardModule };


//# sourceMappingURL=b2c-ui-event-card.js.map